import AccessGroupDeleteModal from './AccessGroupDeleteModal';

export default AccessGroupDeleteModal;
